import { motion, useReducedMotion, useScroll, useTransform } from "framer-motion";
import { useRef } from "react";
import { Reveal, Eyebrow } from "./primitives";
import { MANIFESTO } from "@/lib/content";

const MANIFESTO_IMG =
  "https://images.unsplash.com/photo-1773243086607-0e2d41fb59c9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MDV8MHwxfHNlYXJjaHwyfHxtb3RoZXIlMjBhbmQlMjBuZXdib3JuJTIwYmFieSUyMHRlbmRlcnxlbnwwfHx8fDE3ODY3NjY5OTJ8MA&ixlib=rb-4.1.0&q=85";

export default function Manifesto() {
  const reduce = useReducedMotion();
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], [60, -60]);

  return (
    <section id="promise" ref={ref} data-testid="manifesto-section" className="bg-bone py-24 sm:py-32">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="grid grid-cols-1 gap-12 lg:grid-cols-12 lg:gap-16">
          {/* Sticky intro + image */}
          <div className="lg:col-span-5">
            <div className="lg:sticky lg:top-28">
              <Reveal>
                <Eyebrow>{MANIFESTO.eyebrow}</Eyebrow>
                <h2 className="mt-6 font-serif text-4xl font-medium leading-tight tracking-tight text-ink sm:text-5xl">
                  {MANIFESTO.heading}
                </h2>
                <p className="mt-6 max-w-md text-base leading-relaxed text-stone sm:text-lg">
                  {MANIFESTO.intro}
                </p>
              </Reveal>
              <Reveal delay={0.1} className="mt-10 overflow-hidden rounded-3xl border border-line">
                <motion.img
                  src={MANIFESTO_IMG}
                  alt="A mother holding her newborn baby"
                  style={reduce ? undefined : { y }}
                  className="h-72 w-full scale-110 object-cover sm:h-80"
                />
              </Reveal>
            </div>
          </div>

          {/* Numbered chapters */}
          <div className="lg:col-span-7">
            <div className="flex flex-col">
              {MANIFESTO.chapters.map((c, i) => (
                <Reveal
                  key={c.no}
                  delay={i * 0.05}
                  className="group border-t border-line py-9 first:border-t-0 first:pt-0"
                >
                  <div className="flex items-start gap-6 sm:gap-10">
                    <span className="font-serif text-5xl font-medium text-sage/50 transition-colors duration-500 group-hover:text-terracotta sm:text-6xl">
                      {c.no}
                    </span>
                    <div className="pt-1">
                      <h3 className="font-serif text-2xl font-medium text-ink sm:text-3xl">{c.title}</h3>
                      <p className="mt-3 max-w-xl text-base leading-relaxed text-stone">{c.body}</p>
                    </div>
                  </div>
                </Reveal>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
